export function copayDayStr(dayVal) {
  if (dayVal || dayVal === 0) {
    return dayVal.toLocaleString();
  }
  return '--';
}
